var _style, _path, _path2, _path3, _g, _path4, _g2, _g3, _g4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdited1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-115.19,80.97c0,26.44-21.44,47.88-47.87,47.88c-26.45,0-47.88-21.44-47.88-47.88 c0-26.44,21.43-47.88,47.88-47.88C-136.63,33.09-115.19,54.53-115.19,80.97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-116.01,68.78c15.58,3.21,25.3,7.99,25.3,13.33c0,9.67-32.39,17.5-72.36,17.5c-39.97,0-72.36-7.83-72.36-17.5 c0-5.46,8.94-10,25.13-13.2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.34,328.72c0,40.44-32.77,73.2-73.2,73.2c-40.43,0-73.21-32.77-73.21-73.2c0-40.43,32.78-73.2,73.21-73.2 C290.57,255.52,323.34,288.29,323.34,328.72z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.34,328.72c0-24.04-11.58-45.38-29.48-58.72c-16.6,5.86-36.18,15.73-39.69,25.86 c-5.76,16.72,3.46,13.26,12.68,20.18c1.73,1.73,8.65,1.15,9.81,2.88c3.46,3.46-0.58,8.07,0,8.65c4.61,5.76,13.25,19.02,7.49,29.97 c-3.46,7.48-17.29,9.22-19.6,17.87c-1.77,7.98,4.34,15.65,12.27,21.47C304.05,386.22,323.34,359.74,323.34,328.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.66,312.95c9.08,3.61,22.74,1.17,27.68,10.59c4.04,8.07,10.37,21.9,12.69,30.56 c2.88,9.8-5.77,20.74,6.91,25.93c5.76-7.49,2.88-22.48,15.57-25.93c-2.89-23.06-40.35-25.95-9.81-44.97 c-13.83-7.68,6.44-32.65-7.04-49.03C201.58,268.66,184.02,288.52,178.66,312.95z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-214.08,260.09c0,39.46-31.99,71.46-71.46,71.46c-39.47,0-71.46-32-71.46-71.46c0-39.47,32-71.46,71.46-71.46 C-246.07,188.63-214.08,220.62-214.08,260.09z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-298.45,249.99c0,7.7-6.24,13.93-13.93,13.93c-7.69,0-13.93-6.23-13.93-13.93c0-7.69,6.24-13.93,13.93-13.93 C-304.69,236.06-298.45,242.29-298.45,249.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-250.21,307.07c0,7.7-6.23,13.93-13.92,13.93c-7.7,0-13.94-6.24-13.94-13.93c0-7.7,6.24-13.92,13.94-13.92 C-256.45,293.14-250.21,299.37-250.21,307.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-258.37,274.45c0,5.07-4.11,9.18-9.17,9.18c-5.07,0-9.17-4.11-9.17-9.18c0-5.07,4.11-9.17,9.17-9.17 C-262.47,265.27-258.37,269.38-258.37,274.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-285.71,268c0,2.53-2.05,4.58-4.59,4.58c-2.53,0-4.58-2.05-4.58-4.58c0-2.53,2.05-4.59,4.58-4.59 C-287.76,263.41-285.71,265.46-285.71,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-334.18,246.7c0,3.29-2.66,5.95-5.95,5.95c-3.28,0-5.94-2.66-5.94-5.95c0-3.28,2.66-5.95,5.94-5.95 C-336.84,240.75-334.18,243.42-334.18,246.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-235.43,293.36c0,3.29-2.66,5.94-5.95,5.94c-3.28,0-5.95-2.66-5.95-5.94c0-3.29,2.67-5.95,5.95-5.95 C-238.09,287.41-235.43,290.08-235.43,293.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-316.12,290.42c0,4.88-3.95,8.84-8.83,8.84c-4.88,0-8.84-3.96-8.84-8.84c0-4.87,3.96-8.83,8.84-8.83 C-320.08,281.59-316.12,285.54-316.12,290.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-285.54,287.02c0,4.88-3.95,8.83-8.84,8.83c-4.87,0-8.83-3.94-8.83-8.83c0-4.88,3.96-8.83,8.83-8.83 C-289.5,278.19-285.54,282.14-285.54,287.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-294.38,313.52c0,2.62-2.12,4.75-4.75,4.75c-2.63,0-4.76-2.13-4.76-4.75c0-2.63,2.13-4.76,4.76-4.76 C-296.5,308.77-294.38,310.89-294.38,313.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-333.79,268.68c0,2.61-2.12,4.75-4.75,4.75c-2.63,0-4.76-2.14-4.76-4.75c0-2.63,2.12-4.76,4.76-4.76 C-335.92,263.92-333.79,266.05-333.79,268.68z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.85,232.38c0,39.29-31.85,71.14-71.15,71.14c-39.29,0-71.14-31.85-71.14-71.14 c0-39.29,31.86-71.15,71.14-71.15C-8,161.24,23.85,193.09,23.85,232.38z",
    style: {}
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -110.06,
    y1: 264.17,
    x2: -90,
    y2: 264.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -105.13,
    y1: 272.26,
    x2: -79.45,
    y2: 272.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -98.44,
    y1: 280.36,
    x2: -65.73,
    y2: 280.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -88.94,
    y1: 288.8,
    x2: -54.47,
    y2: 288.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -72.06,
    y1: 297.6,
    x2: -42.16,
    y2: 297.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1.78,225.95c3.61-4.41,2.96-10.9-1.45-14.5l-59.34-48.55c-7.84,1.71-15.19,4.71-21.83,8.78l68.12,55.72 C-11.88,231-5.38,230.35-1.78,225.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-63.33,249.1c3.6-4.4,2.95-10.9-1.45-14.5l-44.78-36.63c-3.49,6.3-6.06,13.2-7.51,20.49l39.23,32.1 C-73.42,254.15-66.93,253.5-63.33,249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.73,268.85c3.6-4.4,2.96-10.89-1.45-14.5l-95.36-78.02c-5.45,4.27-10.26,9.31-14.27,14.96l96.57,79.01 C-4.37,273.91,2.13,273.25,5.73,268.85z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1.040665, 0, 0, 1.036254, -2.825778, -2.809577)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.13,75.01c0,39.28-31.84,71.13-71.13,71.13c-39.29,0-71.14-31.85-71.14-71.13 c0-39.3,31.85-71.15,71.14-71.15C114.3,3.86,146.13,35.71,146.13,75.01z",
    style: {
      visibility: "hidden"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1.01696, 0, 0, 1.019088, -1.668357, -0.590594)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.21,
    y1: 78.71,
    x2: 54.58,
    y2: 37.85
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.39,
    y1: 100.21,
    x2: 51.39,
    y2: 61.73
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.94,
    y1: 114.55,
    x2: 53.51,
    y2: 84.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 31.49,
    y1: 125.71,
    x2: 54.04,
    y2: 105.26
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 45.8,
    y1: 136.85,
    x2: 95.45,
    y2: 93.05
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 61.74,
    y1: 143.22,
    x2: 88.82,
    y2: 118.53
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.72,
    y1: 55.62,
    x2: 36.79,
    y2: 30.94
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 80.06,
    y1: 144.02,
    x2: 98.37,
    y2: 128.09
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdited1);
export default __webpack_public_path__ + "static/media/edited1.dc8b1d4f841d5890f77567931ccfa746.svg";
export { ForwardRef as ReactComponent };